var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partner==='uzima_ug')?_c('DeliveriesUzimaUg',{attrs:{"customer":_vm.customer}}):(_vm.partner==='default')?_c('DeliveriesDefault',{attrs:{"customer":_vm.customer}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }